<template>
  <div class="service-market">
    <div class="service-title">
      <van-nav-bar title="服务市场" left-arrow @click-left="onClickLeft" />
    </div>

    <div class="service-cont">
      <!-- <div v-for="(item,i) in list"
           :key="i"> -->
      <div class="service-list" @click="goSerMarket">
        <div class="service-img">
          <img src="~@/assets/jiet.png" alt="" />
        </div>
        <div class="service-listcont">
          <div class="service-listtitle">
            <div class="service-titlecont">360贷款</div>
          </div>
          <div class="service-desc">
            <div class="service-purch">额度高</div>
            <div class="service-buy">审批快</div>
          </div>
          <div class="service-name">360借条 额度高审批快，最长免息30天</div>
        </div>
      </div>
    </div>
    <!-- </div> -->
  </div>
</template>

<script>
// import { toast } from '@/utils/index'
export default {
  data() {
    return {}
  },
  created() {},
  methods: {
    onClickLeft() {
      // console.log('this.actilc', this.value)
    },
    goSerMarket() {
      const newWindow = window.open('_blank')
      newWindow.location = 'https://mkt.xjietiao.com/activity/ch/whll/lanmu'
    }
  }
}
</script>

<style lang="less" scoped>
.service-market {
  background: #f7f7f7;
  width: 375px;
  min-height: 100vh;
  .service-title {
    .van-nav-bar {
      ::after {
        border: none;
      }
      border: none !important;
      .van-nav-bar__title {
        font-size: 18px;
        color: #333333;
        font-weight: 500;
      }

      .van-nav-bar__left {
        .van-icon {
          color: #666666;
        }
      }
    }
    :after {
      border: none;
    }
  }
  .service-cont {
    // border: 1px solid red;
    .service-list {
      width: 345px;
      height: 135px;
      // border: 1px solid green;
      margin: 20px 15px 0 15px;
      background: #ffffff;
      display: flex;
      align-items: center;
      border-radius: 3px;
    }
    .service-img {
      width: 70px;
      height: 70px;
      // border: 1px solid blue;
      margin: 0 15px;
      img {
        width: 100%;
      }
    }
    .service-listcont {
      font-size: 12px;
      height: 70px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      .service-listtitle {
        display: flex;
        align-items: center;
        .service-titlecont {
          margin-right: 5px;
          font-size: 17px;
          font-weight: bold;
          color: #333333;
        }
      }
      .service-desc {
        font-size: 13px;
        font-weight: 500;
        color: #999999;
        display: flex;
        .service-purch {
          margin-right: 5px;
          // width: 48px;
          font-size: 12px;
          font-weight: 500;
          color: #666666;
          padding: 1px 6px 1px 6px;
          border-radius: 3px;
          border: 1px solid #bfbfbf;
        }
        .service-buy {
          margin-right: 5px;
          font-size: 12px;
          font-weight: 500;
          color: #666666;
          padding: 2px 6px 1px 6px;
          border-radius: 3px;
          border: 1px solid #bfbfbf;
        }
      }
      .service-name {
        font-size: 13px;
        font-weight: 500;
        color: #999999;
      }
    }
  }
}
</style>
